import React, { useState, useEffect, useRef } from "react";
import global from "../../global-variables";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import TrackingCode from "../../hooks/TrackingCode";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import axios from "axios";
import globalVariables from "../../global-variables";
import { HashLink } from "react-router-hash-link";
import $ from "jquery";

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Optional smooth scrolling
  });
};

export default function Header(props) {
  //navbar active
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  //navbar active

  const ref = useRef(null);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [fullscreen, setFullscreen] = useState(true);
  // const pathname = useLocation();

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -134;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  useEffect(() => {
    // Go to Top OR Scroll to top
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation (comment behavior if u want to animate)
    });
  }, [pathname]);

  useEffect(() => {
    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();

    $(document).ready(function () {
      if ($(window).width() >= 1198) {
        $(".dropdown").hover(
          function () {
            $(".dropdown-menu", this)
              .not(".in .dropdown-menu")
              .stop(true, true)
              .slideDown();
            $(this).toggleClass("open");
            $(".offcanvas-overlay").eq(0).addClass("activeoverlay");
            $(".dropdown-menu").addClass("openmenu");
          },
          function () {
            $(".dropdown-menu", this)
              .not(".in .dropdown-menu")
              .stop(true, true)
              .slideUp("400");
            $(this).toggleClass("open");
            $(".offcanvas-overlay").eq(0).removeClass("activeoverlay");
          },
        );
      }
    });
    $(document).ready(function () {
      if ($(window).width() >= 1198) {
        $(".dropend").hover(function () {
          $(".dropdown-menu", this)
            .not(".in .dropdown-menu")
            .stop(true, true)
            .slideDown();
        });
      }
    });
  }, []);

  const [peopleCategory, setPeopleCategoryList] = useState([]);
  const [researchTypeList, setResearchTypeList] = useState([]);
  const [eventVerticalList, setEventVerticalList] = useState([]);

  useEffect(() => {
    let _obj = new Object();
    _obj.pcategory_status = 1;
    setTimeout(() => {
      axios
        .post(
          global.variables.strApiUrl +
            "/peoplecategoryApi/getcategoryHavingPeopleList",
          _obj,
        )
        .then((response_list) => {
          // pass the result in the success function of the respective page
          setPeopleCategoryList(response_list.data[0]);
        });
    }, 300);

    let _obj2 = {
      rtype_status: 1,
    };
    axios
      .post(
        global.variables.strApiUrl +
          "/researchApi/getResearchTypeHavingResearch",
        _obj2,
      )
      .then((response_list) => {
        // pass the result in the success function of the respective page
        setResearchTypeList(response_list.data[0]);
      });

    // let _obj3 = {
    //     "evertical_status" : 1
    // }
    // axios.post(global.variables.strApiUrl + "/eventVerticalApi/getEventVerticalHavingEventList" , _obj3)
    //     .then((response_list) => {
    //         // pass the result in the success function of the respective page
    //         setEventVerticalList(response_list.data[0]);
    //     });
  }, []);

  //serach  function
  function url_generator(url) {
    var url_generated = "";
    // For local host
    if (window.location.href.indexOf("localhost") != -1) {
      url_generated = url;
    }

    //    // For my machine Server
    else if (window.location.href.indexOf("192.168.2.202") != -1) {
      // url_generated = "/a/amnsinternationalschool" + url;
      url_generated = url;
    }

    // For Live server
    else {
      url_generated = url;
    }
    // alert(url_generated);
    return url_generated;
  }

  useEffect(() => {
    $("#btnsearchSite").on("click", function (e) {
      $("#searchSiteerr").html("");
      if ($("#txtSearchSite").val() == "") {
        $("#searchSiteerr").html("Please Enter Search String");
        return;
      } else {
        window.location.href =
          global.variables.strDomainUrl +
          "search-result/" +
          $("#txtSearchSite").val();
      }
    });

    $("#txtSearchSite").keypress(function (e) {
      var key = e.which;
      if (key == 13) // the enter key code
      {
        if ($("#txtSearchSite").val() == "") {
          $("#searchSiteerr").html("Please Enter Search String");
          return;
        } else {
          <Link to=""></Link>;
          window.location.href = url_generator(
            global.variables.strDomainUrl +
              "search-result/" +
              $("#txtSearchSite").val(),
          );
        }
        return false;
      }
    });

    $("#focusOnInput").on("click", function () {
      setTimeout(() => {
        ref.current.focus();
      }, 500);
    });
  });

  let conversion_code = "";

  if (props.conversion_code != undefined) {
    conversion_code = 1;
  } else {
    conversion_code = 2;
  }

  //variable to close left navbar on link click
  const [expanded, setExpanded] = useState(false);

  const isMobileDropdown = () => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < 1198;
  };

  const handleDropdownTitleClick = (e, path) => {
    if (isMobileDropdown()) {
      return; // allow bootstrap to open the mobile dropdown instead of navigating
    }
    e.preventDefault();
    e.stopPropagation();
    scrollToTop();
    setExpanded(false);
    navigate(path);
  };

  // Add event listener for keyboard shortcut
  useEffect(() => {
    // Add Ctrl + K / Cmd + K shortcut
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        e.preventDefault(); // prevent browser's quick search

        // open modal
        handleShow();

        // focus input slightly after modal opens
        setTimeout(() => {
          ref.current?.focus();
        }, 300);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <>
      <Navbar
        expanded={expanded}
        className={props.main_class + " fixed-top p-0 bg-white"}
        collapseonselect
        expand="xl"
      >
        <Container className="d-block">
          <Row className="d-flex justify-content-between ">
            <Col xs={9} md={6} lg={6} xl={5} className="pe-0">
              <div className="logo">
                <Link
                  to="/"
                  onClick={scrollToTop}
                  className="position-relative overflow-hidden"
                >
                  <div className="mb-0 d-inline-block">
                    <img
                      className="img-fluid my-2 my-md-3 animated fadeInUp"
                      loading="lazy"
                      alt="IIT Bombay Research Hub for Green Energy and Sustainability"
                      title="IIT Bombay Research Hub for Green Energy and Sustainability"
                      width={200}
                      height={86}
                      src={global.variables.strDomainUrl + "images/logo.svg"}
                      // src={(global.variables.strDomainUrl + "images/logo.svg")}
                    />
                  </div>
                </Link>
              </div>
            </Col>
            <Col
              xs={3}
              md={6}
              lg={6}
              xl={7}
              className="ps-xxl-5 d-flex flex-column justify-content-center"
            >
              <div className="d-flex justify-content-end align-items-center z-2">
                <div>
                  <ul className="navbar-nav fw-normal top-nav m-0">
                    <li
                      className={`nav-item animated fadeInUp d-xl-block d-none`}
                    >
                      <Link
                        to={globalVariables.variables.strDomainUrl + "news"}
                        onClick={scrollToTop}
                        className="bg-transparent nav-link"
                      >
                        News
                      </Link>
                    </li>
                    {/* <li className={"nav-item animated fadeInUp d-xl-block d-none"}>
                                            <NavDropdown title="Events" className="animated fadeInUp" renderMenuOnMount={true}>
                                            <ul className='px-md-0 px-3 py-xl-2 bg-white rounded-bottom-3'>
                                                {
                                                    eventVerticalList.map((val, index) => {
                                                        return (
                                                            <NavDropdown.Item as="li" key={index}>
                                                                <Link to={`${global.variables.strDomainUrl}events/${val.evertical_pagename}`} onClick={scrollToTop}>{val.evertical_name}</Link>
                                                            </NavDropdown.Item>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </NavDropdown>
                                        </li> */}
                    <li
                      className={`nav-item animated fadeInUp d-xl-block d-none`}
                    >
                      <Link
                        to={globalVariables.variables.strDomainUrl + "events"}
                        onClick={scrollToTop}
                        className="bg-transparent nav-link"
                      >
                        Events
                      </Link>
                    </li>
                    {/* <li className={`nav-item animated fadeInUp d-xl-block d-none`}><Link to={globalVariables.variables.strDomainUrl + 'events'} onClick={scrollToTop} className="bg-transparent nav-link">Events</Link></li> */}
                    <li
                      className={`nav-item animated fadeInUp d-xl-block d-none`}
                    >
                      <Link
                        to={
                          globalVariables.variables.strDomainUrl +
                          "knowledge-hub"
                        }
                        onClick={scrollToTop}
                        className="bg-transparent nav-link"
                      >
                        Knowledge Hub
                      </Link>
                    </li>
                    <li
                      className={"nav-item animated fadeInUp d-xl-block d-none"}
                    >
                      <Link
                        className="bg-transparent nav-link icon-search"
                        id="focusOnInput"
                        onClick={handleShow}
                      >
                        <FiSearch />
                      </Link>
                    </li>
                  </ul>
                </div>
                <Navbar.Toggle
                  onClick={() => setExpanded(expanded ? false : "expanded")}
                  className="offcanvas-toggle shadow-none px-1 animated fadeInUp"
                  aria-controls={"offcanvas-menu"}
                >
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </Navbar.Toggle>
              </div>
              <Navbar.Offcanvas
                id={"offcanvas-menu"}
                aria-labelledby={"offcanvas-menu"}
                placement="end"
                responsive="xl"
                className="px-md-0 px-3 mt-auto"
              >
                <Offcanvas.Header
                  closeButton
                  onClick={() => setExpanded(false)}
                >
                  <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <ul className="navbar-nav mt-xl-auto justify-content-between top-bt-nav">
                  <li
                    className={
                      splitLocation[1] === "about"
                        ? "active"
                        : "" || splitLocation[1] === "people"
                          ? "active"
                          : ""
                    }
                  >
                    <NavDropdown
                      title={
                        <span
                          onClick={(e) => handleDropdownTitleClick(e, "/aboutus")}
                          style={{ cursor: "pointer" }}
                        >
                          About
                        </span>
                      }
                      id="basic-nav-dropdown"
                      className="animated fadeInUp"
                      renderMenuOnMount={true}
                    >
                      <ul className="px-md-0 px-3 py-xl-2 bg-white rounded-bottom-3">
                        <NavDropdown.Item as="li">
                          <Link to="/aboutus">About GESH IITB</Link>
                        </NavDropdown.Item>
                        <NavDropdown
                          title="People"
                          className="dropend dropdown-item bg-white"
                          renderMenuOnMount={true}
                        >
                          <ul className="px-md-0 px-0 py-xl-2 bg-white rounded-bottom-3 dropdown-2">
                            {peopleCategory.map((val_people) => {
                              return (
                                <NavDropdown.Item as="li">
                                  <Link
                                    to={
                                      globalVariables.variables.strDomainUrl +
                                      "people/" +
                                      val_people.pcategory_pagename
                                    }
                                    onClick={() => {
                                      scrollToTop();
                                      setExpanded(false);
                                    }}
                                    id="ClickByRef"
                                  >
                                    {val_people.pcategory_name}
                                  </Link>
                                </NavDropdown.Item>
                              );
                            })}
                            {/* <NavDropdown.Item as="li"><Link to="#">Professor-in-Charge</Link></NavDropdown.Item>
                                                        <NavDropdown.Item as="li"><Link to="#">Advisory Board</Link></NavDropdown.Item>
                                                        <NavDropdown.Item as="li"><Link to="#">Faculty Core Team</Link></NavDropdown.Item>
                                                        <NavDropdown.Item as="li"><Link to="#">GESH Operations Team</Link></NavDropdown.Item> */}
                          </ul>
                        </NavDropdown>
                      </ul>
                    </NavDropdown>
                  </li>
                  <li
                    className={
                      splitLocation[1] === "research"
                        ? "active"
                        : "" || splitLocation[1] === "research-projects"
                          ? "active"
                          : "" || splitLocation[1] === "focus-areas"
                            ? "active"
                            : ""
                    }
                  >
                    <NavDropdown
                      title={
                        <span
                          onClick={(e) => handleDropdownTitleClick(e, "/research")}
                          style={{ cursor: "pointer" }}
                        >
                          Research
                        </span>
                      }
                      className="animated fadeInUp"
                      renderMenuOnMount={true}
                    >
                      <ul className="px-md-0 px-3 py-xl-2 bg-white rounded-bottom-3">
                        <NavDropdown.Item as="li">
                          <Link to="/research">Overview</Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <Link to="/focus-areas">Focus Areas</Link>
                        </NavDropdown.Item>
                        {researchTypeList.map((val, index) => {
                          return (
                            <NavDropdown.Item as="li" key={index}>
                              <a
                                href={`${global.variables.strDomainUrl}research-projects/${val.rtype_pagename}`}
                                onClick={scrollToTop}
                              >
                                {val.rtype_name}
                              </a>
                            </NavDropdown.Item>
                          );
                        })}
                      </ul>
                    </NavDropdown>
                  </li>
                  <li
                    className={splitLocation[1] === "education" ? "active" : ""}
                  >
                    <NavDropdown
                      title={
                        <span
                          onClick={(e) => handleDropdownTitleClick(e, "/education")}
                          style={{ cursor: "pointer" }}
                        >
                          Training and Education
                        </span>
                      }
                      id="basic-nav-dropdown"
                      className="animated fadeInUp"
                      renderMenuOnMount={true}
                    >
                      <ul className="px-md-0 px-3 py-xl-2 bg-white rounded-bottom-3">
                        <NavDropdown.Item as="li">
                          <Link to="/education">Overview</Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <HashLink
                            to="/education/#IITBCourses"
                            onClick={() => setExpanded(false)}
                            scroll={(el) => scrollWithOffset(el)}
                          >
                            IITB Courses
                          </HashLink>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <HashLink
                            to="/education/#IndustryTrainingPrograms"
                            onClick={() => setExpanded(false)}
                            scroll={(el) => scrollWithOffset(el)}
                          >
                            Industry Training Programs
                          </HashLink>
                        </NavDropdown.Item>
                        {/* <NavDropdown.Item as="li"><HashLink to="/education/#EPGD" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>EPGD</HashLink></NavDropdown.Item> */}
                        <NavDropdown.Item as="li">
                          <HashLink
                            to="/education/#Online_Courses"
                            onClick={() => setExpanded(false)}
                            scroll={(el) => scrollWithOffset(el)}
                          >
                            Online Courses
                          </HashLink>
                        </NavDropdown.Item>
                      </ul>
                    </NavDropdown>
                  </li>

                  <li
                    className={
                      splitLocation[1] === "campus-sustainability"
                        ? "active"
                        : ""
                    }
                  >
                    <NavDropdown
                      title={
                        <span
                          onClick={(e) => handleDropdownTitleClick(e, "/campus-sustainability")}
                          style={{ cursor: "pointer" }}
                        >
                          Campus Sustainability
                        </span>
                      }
                      id="basic-nav-dropdown"
                      className="animated fadeInUp"
                      renderMenuOnMount={true}
                    >
                      <ul className="px-md-0 px-3 py-xl-2 bg-white rounded-bottom-3">
                        <NavDropdown
                          title="Sustainability @ IITB"
                          className="dropend dropdown-item bg-white geshiitb border-top-0"
                          renderMenuOnMount={true}
                        >
                          <ul className="px-md-0 px-0 py-xl-2 bg-white rounded-bottom-3 dropdown-2">
                            <NavDropdown.Item as="li">
                              <Link to="/campus-sustainability">Policy</Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item as="li">
                              <Link to="/campus-sustainability/initiatives">
                                Initiatives
                              </Link>
                            </NavDropdown.Item>
                          </ul>
                        </NavDropdown>
                        <NavDropdown
                          title="GESH IITB Living Lab Program"
                          className="dropend dropdown-item bg-white geshiitb"
                          renderMenuOnMount={true}
                        >
                          <ul className="px-md-0 px-0 py-xl-2 bg-white rounded-bottom-3 dropdown-2">
                            <NavDropdown.Item as="li">
                              <Link to="/campus-sustainability/gesh-iitb-living-lab-program">
                                Overview
                              </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item as="li">
                              <Link to="/campus-sustainability/gesh-fellows">
                                Living Lab Fellows
                              </Link>
                            </NavDropdown.Item>
                            <NavDropdown.Item as="li">
                              <Link to="/campus-sustainability/projects">
                                Living Lab Projects
                              </Link>
                            </NavDropdown.Item>
                          </ul>
                        </NavDropdown>
                      </ul>
                    </NavDropdown>
                  </li>
                  <li
                    className={splitLocation[1] === "outreach" ? "active" : ""}
                  >
                    <NavDropdown
                      title={
                        <span
                          onClick={(e) => handleDropdownTitleClick(e, "/outreach/partners")}
                        >
                          Outreach
                        </span>
                      }
                      id="basic-nav-dropdown"
                      className="animated fadeInUp"
                      renderMenuOnMount={true}
                    >
                      <ul className="px-md-0 px-3 py-xl-2 bg-white rounded-bottom-3">
                        <NavDropdown.Item as="li">
                          <Link to="/outreach/partners">Partnerships</Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <Link
                            to={
                              globalVariables.variables.strDomainUrl + "events"
                            }
                            onClick={scrollToTop}
                          >
                            Events
                          </Link>
                        </NavDropdown.Item>
                      </ul>
                    </NavDropdown>
                  </li>
                  <li className={`nav-item animated fadeInUp d-xl-none`}>
                    <Link
                      to={globalVariables.variables.strDomainUrl + "news"}
                      onClick={() => {
                        scrollToTop();
                        setExpanded(false);
                      }}
                      className="nav-link"
                    >
                      News
                    </Link>
                  </li>
                  <li className={`nav-item animated fadeInUp d-xl-none`}>
                    <Link
                      to={globalVariables.variables.strDomainUrl + "events"}
                      onClick={() => {
                        scrollToTop();
                        setExpanded(false);
                      }}
                      className="nav-link"
                    >
                      Events
                    </Link>
                  </li>
                  <li className={`nav-item animated fadeInUp d-xl-none`}>
                    <Link
                      to={
                        globalVariables.variables.strDomainUrl + "knowledge-hub"
                      }
                      onClick={() => {
                        scrollToTop();
                        setExpanded(false);
                      }}
                      className="nav-link"
                    >
                      Knowledge Hub
                    </Link>
                  </li>
                  <li className="nav-item animated fadeInUp d-xl-none">
                    <Link
                      to="/careers"
                      className="nav-link"
                      onClick={() => {
                        scrollToTop();
                        setExpanded(false);
                      }}
                    >
                      Careers
                    </Link>
                  </li>
                  <li className="nav-item animated fadeInUp d-xl-none">
                    <HashLink
                      to="#contact"
                      className="nav-link"
                      onClick={() => setExpanded(false)}
                      scroll={(el) => scrollWithOffset(el)}
                    >
                      Contact Us
                    </HashLink>
                  </li>
                </ul>
              </Navbar.Offcanvas>
            </Col>
          </Row>
        </Container>

        <Modal
          show={show}
          fullscreen={fullscreen}
          onHide={handleClose}
          className="bg-search-panel"
        >
          <Modal.Body className="d-flex justify-content-center align-items-center">
            <Container className="d-flex align-items-center flex-column">
              <div className="col-md-8 mx-auto">
                <Modal.Header
                  closeButton
                  className="border-0 py-md-5 py-4 h5 ms-auto"
                >
                  <Modal.Title></Modal.Title>
                </Modal.Header>
                <InputGroup className="mb-3 border rounded bg-white">
                  <Form.Control
                    className="border-0 form-control-lg shadow-none"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby=""
                    required=""
                    id="txtSearchSite"
                    ref={ref}
                  />
                  <span
                    id="searchSiteerr"
                    class="text-danger me-2"
                    style={{ "margin-top": " 10px", "margin-right": "5px" }}
                  ></span>
                  <Button variant="outline-dark border-0" id="btnsearchSite">
                    <FiSearch />
                  </Button>
                </InputGroup>
              </div>
            </Container>
          </Modal.Body>
        </Modal>
      </Navbar>
      <TrackingCode conversion_code={conversion_code} />
    </>
  );
}
